import React, { useEffect, useState } from "react";

import { Layout } from "antd";

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";
import { message } from "antd";
import Topbar from "../Topbar/index";
import NewRoutes from "../../routes/newRoutes";
import SubmenuTabs from "../../components/SubmenuTabs/SubmenuTabs";

import { useSelector } from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import { useRouteMatch, useLocation } from "react-router-dom";
import Customizer from "../Customizer";
import MiraFloatingButton from "../../components/ai/MiraFloatingButton";
import useAutoLogoutOnTabClose from "../../hooks/useAutoLogoutOnTabClose";

const { Content } = Layout;

const MainApp = () => {
  useAutoLogoutOnTabClose();
  const { navStyle } = useSelector(({ settings }) => settings);
  const match = useRouteMatch();
  const location = useLocation();
  let [isSSoLogin, setIsSSOLogin] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const redirect_uri = queryParams.get("redirect_uri");
  message.config({
    maxCount: 1,
  });
  useEffect(() => {
    if (redirect_uri) {
      setIsSSOLogin(true);
    }
  }, []);

  // Company-wide Date Format setting (Settings → Date/Time Configurations)
  // and time calculation mode ("hours"|"minutes") - both set into Redux
  // (common.dateFormat / common.timeCalculationMode) from App/index.js's
  // getUserInfo() response (getempbyid/userById already run for every user
  // on every app load as part of login/bootstrap) instead of a separate
  // fetch here, so neither depends on its own fire-and-forget round trip
  // succeeding.

  // Zoho Payroll OAuth: success/error land on redirectPath (e.g. /{slug}/dashboard) with query params
  useEffect(() => {
    const search = location.search;
    if (!search || !search.includes("zoho_")) return;
    const q = new URLSearchParams(search);
    const connected = q.get("zoho_connected");
    const zohoErr = q.get("zoho_error");
    if (connected === "true") {
      message.success("Zoho Payroll connected successfully.");
      q.delete("zoho_connected");
    } else if (zohoErr) {
      message.error(decodeURIComponent(zohoErr));
      q.delete("zoho_error");
    } else {
      return;
    }
    const next = q.toString();
    const nextUrl = `${location.pathname}${next ? `?${next}` : ""}`;
    window.history.replaceState({}, "", nextUrl);
  }, [location.pathname, location.search]);


  const getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return "";
    }
  };
  const getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  return (
    <>
      <Layout className="gx-app-layout">
      {!isSSoLogin && <Sidebar /> }
        <Layout>
        {!isSSoLogin && getNavStyles(navStyle)}
        {!isSSoLogin && <SubmenuTabs />}
          <Content
            className={ `gx-layout-content ${getContainerClass(navStyle)} ` }
          >
            <NewRoutes match={ match } />
          </Content>
          <Customizer />
        </Layout>
      </Layout>
      {!isSSoLogin && <MiraFloatingButton />}
    </>
  );
};
export default MainApp;
